import { Injectable } from "@angular/core";
import { HttpClient } from "../shared/wrappers/HttpClient";

@Injectable()
export class ExcellenceCentersService {
    endPoint: String = "/excellence-centers";
    supportCenterEndPoint: String = "/support-centers";

    constructor(private httpClient: HttpClient) { }

    async getAll() {
        return  await this.httpClient.get(`${this.endPoint}`, '');
    }
}



// WEBPACK FOOTER //
// ./src/app/services/excellenceCenters.service.ts